const NUMBERS = "0123456789";
const LOWERCASE = "abcdefghijklmnopqrstuvwxyz";
const UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const SYMBOLS = "!@#$%^&*";

const allCharacters = NUMBERS.concat(LOWERCASE, UPPERCASE, SYMBOLS);

const PASSWORD_LENGTH = 10;

const pickCharacterFromString = (str: string) => {
  if (str === "") return "";

  return str[Math.floor(Math.random() * str.length)];
};

const randomiseCharacters = (chars: string[]) => {
  const randomised: string[] = [];

  while (chars.length > 0) {
    const r = Math.floor(Math.random() * chars.length);
    const char = chars.splice(r, 1)[0];
    randomised.push(char);
  }

  return randomised;
};

// Password must be 10 characters
// Password must contain three of the following: uppercase, lowercase, number, symbol
export const generatePassword = (): string => {
  const chars: string[] = [];
  for (let i = 0; i < PASSWORD_LENGTH; i++) {
    chars.push(pickCharacterFromString(allCharacters));
  }

  const hasNumber = chars.some(char => NUMBERS.indexOf(char) !== -1);
  const hasLowercase = chars.some(char => LOWERCASE.indexOf(char) !== -1);
  const hasUppercase = chars.some(char => UPPERCASE.indexOf(char) !== -1);
  const hasSymbols = chars.some(char => SYMBOLS.indexOf(char) !== -1);

  const numDifferentTypes =
    Number(hasNumber) +
    Number(hasLowercase) +
    Number(hasUppercase) +
    Number(hasSymbols);

  if (numDifferentTypes < 3) {
    // invalid password, so try again
    return generatePassword();
  }

  return randomiseCharacters(chars).join("");
};
